import { Button } from '@ipfabric/ui-components/Button/Button';
import { useState } from 'react';

export interface WizardNavigationButtonsProps {
  onPrevious?: () => void | Promise<void>;
  previousText?: string;
  onNext?: () => void | Promise<void>;
  nextText?: string;
  isLoading?: boolean;
}

export const WizardNavigationButtons = ({
  onPrevious,
  previousText = 'Previous',
  onNext,
  isLoading = false,
  nextText = 'Next',
}: WizardNavigationButtonsProps) => {
  const [clicked, setClicked] = useState<'prev' | 'next' | null>(null);
  return (
    <div className='p flex flex-col gap items-center'>
      <div className='flex gap-xs'>
        <Button
          variant='outline'
          className='w-28'
          disabled={isLoading || !onPrevious}
          loading={isLoading && clicked === 'prev'}
          onClick={() => {
            setClicked('prev');
            onPrevious?.();
          }}
        >
          {previousText}
        </Button>

        <Button
          variant='primary'
          className='w-28'
          disabled={isLoading || !onNext}
          loading={isLoading && clicked === 'next'}
          onClick={() => {
            setClicked('next');
            onNext?.();
          }}
        >
          {nextText}
        </Button>
      </div>
    </div>
  );
};
